import { render, staticRenderFns } from "./AccountingBalance.vue?vue&type=template&id=804f0086&scoped=true"
import script from "./AccountingBalance.vue?vue&type=script&lang=js"
export * from "./AccountingBalance.vue?vue&type=script&lang=js"
import style0 from "./AccountingBalance.vue?vue&type=style&index=0&id=804f0086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804f0086",
  null
  
)

export default component.exports